import styled from 'styled-components';

export const Header = styled.div`
	font-weight: 600;
`;

export const Body = styled.div`
	font-weight: normal;
`;

export const Footer = styled.div`
	opacity: 0.5;
`;
